import {Deserializable} from './deserializable';
import { DevicePilomatIO } from './devicePilomatIO';


export class DevicePilomatIOs implements Deserializable {
  ios: DevicePilomatIO[];

  deserialize(input: any) {
    
    Object.assign(this, input);
    if (!input) {
      return this;
    }

    return this;
  }
}
